import angular from 'angular';
import 'ng-redux'
import { store } from '../../redux/store/store'

const utilsModule = angular.module('utils',['ngRedux'])

utilsModule.constant('appInfo', {});

utilsModule.config(['$ngReduxProvider',function($ngReduxProvider) {
    $ngReduxProvider.provideStore(store)
}])

export {utilsModule}